export class EcmGroupModel {
  id: string;
  description: string;
  value: string;
}